import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  section: {
    width: '100%',
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(-2),
  },
  textWithCopy: {
    display: 'flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
}))
